import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiZap, FiLinkedin, FiFacebook, FiTwitter } from 'react-icons/fi';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          {/* Brand */}
          <div style={styles.col}>
            <div style={styles.brand}>
              <FiZap size={20} color="var(--accent)" />
              <span style={styles.brandText}>ReplyCraft</span>
            </div>
            <p style={styles.brandDesc}>AI-powered email and message reply generator. Get perfect replies in seconds.</p>
            <div style={styles.contactInfo}>
              <a href="mailto:support@replycraft.io" style={styles.contactLink}>
                <FiMail size={14} /> support@replycraft.io
              </a>
              <a href="sms:+15403227406" style={styles.contactLink}>
                <FiPhone size={14} /> (540) 322-7406 <span style={styles.textOnly}>Text only</span>
              </a>
            </div>
            <div style={styles.socials}>
              <a href="https://www.linkedin.com/company/replycraft-io" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="LinkedIn">
                <FiLinkedin size={18} />
              </a>
              <a href="https://www.facebook.com/replycraft.official" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="Facebook">
                <FiFacebook size={18} />
              </a>
              <a href="https://x.com/Replycraft_io" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="X (Twitter)">
                <FiTwitter size={18} />
              </a>
            </div>
          </div>

          {/* Product */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Product</h4>
            <Link to="/how-it-works" style={styles.link}>How It Works</Link>
            <Link to="/pricing" style={styles.link}>Pricing</Link>
            <Link to="/extension" style={styles.link}>Chrome Extension</Link>
            <Link to="/blog" style={styles.link}>Blog</Link>
            <Link to="/contact" style={styles.link}>Contact Us</Link>
          </div>

          {/* Support */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Support</h4>
            <Link to="/faq" style={styles.link}>FAQ</Link>
            <Link to="/contact" style={styles.link}>Feedback & Suggestions</Link>
            <a href="mailto:support@replycraft.io" style={styles.link}>Email Support</a>
          </div>

          {/* Legal */}
          <div style={styles.col}>
            <h4 style={styles.colTitle}>Legal</h4>
            <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
            <Link to="/terms" style={styles.link}>Terms of Service</Link>
            <p style={styles.refundNotice}>All credit purchases are final and non-refundable.</p>
          </div>
        </div>

        <div style={styles.bottom}>
          <p style={styles.copyright}>&copy; {new Date().getFullYear()} ReplyCraft | GrammarCheck LLC. All rights reserved.</p>
          <p style={styles.refundBottom}>All sales are final. Credits are non-refundable once purchased.</p>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: { borderTop: '1px solid var(--border)', background: 'var(--bg-secondary)', padding: '48px 20px 24px', marginTop: 'auto' },
  container: { maxWidth: 1000, margin: '0 auto' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 24, marginBottom: 32 },
  col: { display: 'flex', flexDirection: 'column', gap: 8 },
  brand: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 },
  brandText: { fontSize: 20, fontWeight: 700, color: 'var(--accent)' },
  brandDesc: { fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5, marginBottom: 12 },
  contactInfo: { display: 'flex', flexDirection: 'column', gap: 8 },
  contactLink: { display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: 13, textDecoration: 'none' },
  socials: { display: 'flex', gap: 12, marginTop: 12 },
  socialLink: { color: 'var(--text-muted)', transition: 'color 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: '50%', border: '1px solid var(--border)', textDecoration: 'none' },
  textOnly: { fontSize: 11, color: 'var(--text-muted)', background: 'var(--bg-primary)', padding: '1px 6px', borderRadius: 4 },
  colTitle: { fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.5 },
  link: { color: 'var(--text-secondary)', fontSize: 14, textDecoration: 'none', transition: 'color 0.2s', padding: '2px 0' },
  refundNotice: { fontSize: 11, color: 'var(--text-muted)', marginTop: 4, lineHeight: 1.4, fontStyle: 'italic' },
  bottom: { borderTop: '1px solid var(--border)', paddingTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 },
  copyright: { fontSize: 13, color: 'var(--text-muted)', whiteSpace: 'nowrap' },
  refundBottom: { fontSize: 12, color: 'var(--text-muted)', fontStyle: 'italic' }
};
